<div fxFlex="column" class="grade-dialog">
  <div class="dialog-header">
    {{ title }}
  </div>

  <div class="grade-container" fxLayout="column">
    <!-- <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-20">
      <div class="form-key">Assigning Lessons</div>
    </div> -->
    <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-20">
      <mat-accordion class="width-100">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="accordion"> Assigning Lessons </mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li *ngFor="let subtask of arrAssignment">
              <mat-checkbox
                [(ngModel)]="subtask.selected"
              >
                {{ subtask.assignmentName }}
              </mat-checkbox>
            </li>
          </ul>
        </mat-expansion-panel>
      </mat-accordion>

    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-20">
      <div fxFlex="50" class="form-key title">Assignment Options</div>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-20">
      <div fxFlex="50" class="form-key">
        <mat-form-field>
          <input class="disable"
            placeholder="Start Date"
            matInput readonly
            [matDatepicker]="picker"
            [(ngModel)]="StartDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>
      <div fxFlex="10"></div>
      <div fxFlex="40" class="form-key">
        Remove extended response<br />
        <mat-slide-toggle
          [(ngModel)]="RemoveExtendedResponse"
          class="slide-toggle"
        ></mat-slide-toggle>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-20">
      <div fxFlex="45" class="form-key">
        <mat-form-field>
          <input class="disable"
            placeholder="End Date"
            matInput readonly
            [matDatepicker]="endpicker"
            [(ngModel)]="EndDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="endpicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #endpicker disabled="false"></mat-datepicker>
        </mat-form-field>
      </div>
      <div fxFlex="40" class="form-key">
        Assign lesson(s) to students who already have this lesson<br />
        <mat-slide-toggle
          [(ngModel)]="AssignOnlyUnassignedStudents"
          class="slide-toggle"
        ></mat-slide-toggle>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxFlex="50" class="form-key title">Choose Classes & Students</div>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      *ngIf="!isAdmin"
    >
      <div fxFlex="100">
        <mat-form-field fxFlex="90">
          <mat-select
            panelClass="myFilter"
            [(ngModel)]="selectedClassess"
            multiple
            (selectionChange)="changeClassSelection($event)"
          >
            <mat-option
              *ngFor="let topping of arrClasses; let i = index"
              [value]="topping"
              >{{ topping?.ClassName }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      *ngIf="isAdmin"
    >
      <div fxFlex="100">
        <mat-form-field fxFlex="90">
          <mat-select
            [(ngModel)]="selectedClassess"
            multiple
            (selectionChange)="GetClassesWithStudent($event)"
          >
            <mat-option
              *ngFor="let topping of arrClasses; let i = index"
              [value]="topping"
              >{{ topping?.ClassName }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="mb-20"
      *ngIf="selectedClassess?.length > 0"
    >
      <div fxFlex="90">
        <div class="checkbox-container mb-10" *ngFor="let cData of selectedClassess">
          <i
            class="fa fa-caret-down"
            aria-hidden="true"
            *ngIf="isCaretDown[cData?.HBClassID]"
            (click)="isCaretDown[cData?.HBClassID] = false"
          ></i>
          <i
            class="fa fa-caret-right"
            aria-hidden="true"
            *ngIf="!isCaretDown[cData?.HBClassID]"
            (click)="isCaretDown[cData?.HBClassID] = true"
          ></i>
          &nbsp;&nbsp;&nbsp;<mat-checkbox
            class="filter-cb"
            (click)="$event.stopPropagation()"
            [checked]="cData.checked"
            [(ngModel)]="cData.checked"
            (change)="changeClassCheckboxValue(cData)"
          >
            {{ cData?.ClassName }}
          </mat-checkbox>
          <ng-container *ngIf="isCaretDown[cData?.HBClassID]">
            <div
              *ngFor="let subtask of cData?.Students"
              style="margin-left: 45px"
            >
              <mat-checkbox
                class="sub-filter-cb"
                (click)="$event.stopPropagation()"
                [(ngModel)]="subtask.checked"
              >
                {{ subtask.StudentName }}
              </mat-checkbox>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="button-container" fxLayout="row" fxLayoutAlign="space-around">
      <div>
        <button
          class="cancel-button button"
          mat-button
          type="button"
          (click)="onCancel()"
        >
          Cancel
        </button>
      </div>
      &nbsp;&nbsp;&nbsp;
      <div>
        <button
          class="submit-button button"
          mat-button
          type="button"
          (click)="onSubmit()"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
